import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, FormField, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const AddressingNameStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [body, setBody] = useState<string[] | null>(null);
  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.addressing_name).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);
  const onNext = () => goNext(); // optional field
  return (
    <StepContainer title="Adresseringsnavn">
      {body ? (
        <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>
      ) : (
        <InfoBox type="info"><p>Kun muligt for ansøgere, der tidligere har haft registreret et adresseringsnavn.</p></InfoBox>
      )}
      <div style={{ maxWidth: 480 }}>
        <FormField
          name="addressingName"
          value={selfServiceData.addressingName || ''}
          placeholder="Adresseringsnavn (valgfrit)"
          onChange={(e) => updateSelfServiceData('addressingName', e.target.value)}
        />
      </div>
      <NavigationButtons onBack={goBack} onNext={onNext} />
    </StepContainer>
  );
};

export default AddressingNameStep;
